import { generatePath, Navigate, Outlet, useLocation } from "react-router";

import { PATHS } from "@/routes/paths";

import { useAuth } from "@/providers";

const AUTH_INVITATION_PAGE_PATH = generatePath(PATHS.AUTH.INVITATION.ONE_TIME_PASS, { companyID: "", oneTimePass: "" });

export const AuthRouteGuard = () => {
	const { isSignedIn } = useAuth();
	const { pathname } = useLocation();
	const isAuthInvitationPage = pathname.startsWith(AUTH_INVITATION_PAGE_PATH);

	if (isSignedIn && !isAuthInvitationPage) {
		// サインしている & アカウント作成ページではない場合はTOPページに遷移する
		return <Navigate to={PATHS.TOP} replace />;
	}

	// アカウント作成ページにはサインしている場合でも遷移する（TOPページには遷移しない）
	return <Outlet />;
};

AuthRouteGuard.displayName = "AuthRouteGuard";
